<template>
  <!-- 申请报名 -->
  <div class="shenqingbaoming">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <div class="titlebox">
      <p class="title">申请报名</p>
      <div class="line"></div>
    </div>
    <img
      @click="getTo53Kf"
      class="shenqingbaoming_img"
      src="../../assets/images/shenqingbaoming/shenqingbaoming_img.png"
    />
    <!-- 表单 -->
    <div class="box7form">
      <img
        class="imgicon"
        src="../../assets/images/shenqingbaoming/biaodan_icon.png"
      />
      <div class="formbox">
        <div class="formbk">
          <p class="title1">韩国东国大学申请报名</p>
          <p class="title2">让你轻松实现学历提升的梦想</p>
          <el-form :model="formLabelAlign" label-width="0px">
            <el-form-item>
              <p><span class="icon">*</span>您的姓名</p>
              <el-input
                v-model.trim="formLabelAlign.name"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <p><span class="icon">*</span>联系方式</p>
              <el-input
                v-model="formLabelAlign.phone"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <p><span class="icon">*</span>当前学历</p>
              <el-select
                v-model="formLabelAlign.xueli"
                placeholder="请输入当前学历"
              >
                <el-option
                  v-for="item in formxueliList"
                  :key="item.S99_CodeId"
                  :label="item.S99_Name"
                  :value="item.S99_CodeId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <p><span class="icon" style="opacity: 0">*</span>意向专业</p>
              <el-input
                v-model.trim="formLabelAlign.zhuanye"
                placeholder="请输入意向专业"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="button" @click="sbmitForm">提交</div>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <!-- <ul class="biaoge">
      <li>
        <div>姓名</div>
        <p>李xx</p>
        <p>王xx</p>
        <p>岳xx</p>
        <p>陈xx</p>
        <p>郑xx</p>
        <p>林xx</p>
        <p>曲xx</p>
        <p>申xx</p>
      </li>
      <li>
        <div>联系方式</div>
        <p>137****9831</p>
        <p>136****6372</p>
        <p>131****7736</p>
        <p>138****8295</p>
        <p>158****7442</p>
        <p>151****5374</p>
        <p>138****7776</p>
        <p>131****7351</p>
      </li>
      <li>
        <div>院校</div>
        <p>韩国东国大学</p>
        <p>韩国东国大学</p>
        <p>韩国东国大学</p>
        <p>韩国东国大学</p>
        <p>韩国东国大学</p>
        <p>韩国东国大学</p>
        <p>韩国东国大学</p>
        <p>韩国东国大学</p>
      </li>
      <li>
        <div>专业</div>
        <p>影像制作学</p>
        <p>影像制作学</p>
        <p>影像制作学</p>
        <p>影像制作学</p>
        <p>影像制作学</p>
        <p>影像制作学</p>
        <p>影像制作学</p>
        <p>影像制作学</p>
      </li>
    </ul> -->
  </div>
</template>
<script>
import Vue from "vue";
import { Notify } from "vant";
export default {
  metaInfo() {
    return {
      title: "申请报名-韩国东国大学中文官网",
      meta: [
        {
          name: "keywords",
          content:
            "东国大学申请,东国大学报名,影像制作学申请报名,东国大学硕士申请",
        },
        {
          name: "description",
          content:
            "韩国东国大学中文官网为留学生提供申请报名服务包含东国大学申请报名、东国大学硕士申请报名、影像制作学申请报名等，韩国东国大学中文官网全程为您的韩国留学生涯保驾护航。",
        },
      ],
    };
  },
  data() {
    return {
      //form表单
      formxueliList: [],
      formLabelAlign: {
        name: "", //您的姓名
        phone: "", //联系方式
        xueli: "", //目前学历
        zhuanye: "", //意向专业
      },
    };
  },
  mounted() {
    //获取form表单学历
    this.$axios
      .post("/trip/TokenPass/GetClueCode", {
        S99_GroupCode: "035",
      })
      .then((res) => {
        res.data.Data.forEach((element) => {
          this.formxueliList.push(element);
        });
      });
  },
  methods: {
    //打开53客服
    getTo53Kf() {
      window.open(
        "https://tb.53kf.com/code/client/b48a6d9b24a8fba55ca6210e9cad74971/7"
      );
    },
    //form表单提交
    sbmitForm() {
      let _form = this.formLabelAlign;
      if (!_form.name) {
        Notify({ type: "warning", message: "请输入姓名！" });
        return false;
      }
      if (!this.formLabelAlign.phone) {
        Notify({ type: "warning", message: "请输入手机号码" });
        return true;
      } else {
        if (!Number(this.formLabelAlign.phone)) {
          Notify({ type: "warning", message: "手机号码只能为数字类型！" });
          this.formLabelAlign.phone = "";
          return false;
        }
      }
      if (!_form.xueli) {
        Notify({ type: "warning", message: "请输选择当前学历！" });
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: _form.name, //姓名
          C01_Tel: _form.phone, //联系方式
          EducationCode: _form.xueli, //当前学历
          C01_Major: _form.zhuanye, //意向专业
          C01_Origin: 239, //来源于那个官网
        })
        .then((res) => {
          if (res.data.Code == 200) {
            Notify({ type: "success", message: "提交成功！" });
            this.formLabelAlign.name = "";
            this.formLabelAlign.phone = "";
            this.formLabelAlign.xueli = "";
            this.formLabelAlign.zhuanye = "";
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.shenqingbaoming {
  width: 750px;
  margin: 0 auto;
  margin-top: 134px;
  padding-top: 60px;
  margin-bottom: 81px;
  .titlebox {
    margin-left: 296px;
    margin-bottom: 50px;
    .title {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      line-height: 36px;
    }
    .line {
      width: 60px;
      height: 8px;
      background: #f7901e;
      margin-top: -7px;
    }
  }
  .shenqingbaoming_img {
    width: 670px;
    height: 325px;
    display: block;
    margin: 0 auto;
  }
  //表单
  .box7form {
    width: 670px;
    background: #fff9f2;
    margin: 0 auto;
    padding-top: 49px;
    padding-bottom: 60px;
    position: relative;
    margin-top: 62px;
    .imgicon {
      width: 45px;
      height: 41px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .formbox {
      width: 600px;
      margin: 0 auto;
      .title1 {
        letter-spacing: 1px;
        text-align: center;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #222222;
        line-height: 36px;
      }
      .title2 {
        font-size: 19px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
        letter-spacing: 1px;
        text-align: center;
        margin-top: 19px;
      }
      /deep/.el-form {
        padding-top: 40px;
        width: 600px;
        margin: 0 auto;
        .el-form-item {
          margin-bottom: 20px;
          p {
            display: flex;
            position: absolute;
            z-index: 1;
            top: 0px;
            left: 20px;
            color: #222222;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            .icon {
              color: #ff0000;
              margin-right: 5px;
            }
          }
          .el-input__suffix {
            right: 30px;
          }
          .el-form-item__content {
            height: 77px;
            line-height: 77px;
            .el-input__inner {
              padding-left: 164px;
              font-size: 20px;
              line-height: 77px;
              width: 600px;
              height: 77px;
              background: #ffffff;
              border: 1px solid #cbcbcb;
              border-radius: 5px;
            }
          }
        }
      }
      .button {
        width: 600px;
        background: #f7901e;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.13);
        border-radius: 5px;
        text-align: center;
        margin: 0 auto;
        cursor: pointer;
        letter-spacing: 4px;
        font-size: 28px;
       
        font-weight: bold;
        color: #ffffff;
        margin-top: 40px;
        padding-top: 18px;
        padding-bottom: 16px;
      }
    }
  }
  //表格
  .biaoge {
    width: 670px;
    margin: 0 auto;
    display: flex;
    margin-top: 60px;
    li {
      div {
        height: 39px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 39px;
        border: 1px solid #b5b5b5;
        border-top: none;
        border-bottom: none;
      }
      p {
        background: #ffffff;
        height: 56px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        line-height: 56px;
        text-align: center;
        border: 1px solid #b5b5b5;
        border-top: none;
      }
    }
    li:nth-child(1) {
      div,
      p {
        width: 145px;
      }
    }
    li:nth-child(2) {
      div,
      p {
        width: 188px;
      }
    }
    li:nth-child(3) {
      div,
      p {
        width: 167px;
      }
    }
    li:nth-child(4) {
      div,
      p {
        width: 166px;
      }
    }
    li:nth-child(1),
    li:nth-child(3) {
      background: #334477;
    }
    li:nth-child(2),
    li:nth-child(4) {
      background: #f8963e;
    }
    li:nth-child(2),
    li:nth-child(3),
    li:nth-child(4) {
      div {
        border-left: none;
      }
      p {
        border-left: none;
      }
    }
  }
}
</style>
